import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import useConfirm from './useConfirm';
import CircleExlamation from '../../../../assets/images/CircleExlamation';

function ConfirmationContainer() {
  const { title = '', description = '', isOpen = false, proceed, cancel, infoPopup, infoType } = useConfirm();
  const onHide = async () => {
    cancel();
  };

  const onSuccess = async () => {
    proceed();
  };

  const getColorCoding = () => {
    if (!infoType) {
      return 'orange';
    }
    switch (infoType) {
      case 'danger':
        return 'red';
      case 'info':
        return 'blue';
      case 'warning':
        return 'orange';
      default:
        return 'green';
    }
  };

  return (
    <Modal show={isOpen} onHide={onHide} className='mt-5'>
      <Modal.Body>
        <div className="d-flex col-12">
          <div className="col-4 text-center p-5">
            <CircleExlamation color={getColorCoding()} />
          </div>
          <div className="col-8 justify-content-center d-flex flex-column">
            <div className="h5">{title}</div>
            <div>{description}</div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {infoPopup !== true && (
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        )}
        <Button variant={infoPopup !== true ? 'outline-warning' : 'outline-dark'} onClick={onSuccess}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export default ConfirmationContainer;
